import { render, staticRenderFns } from "./video-person.vue?vue&type=template&id=0efb96e6&"
import script from "./video-person.vue?vue&type=script&lang=js&"
export * from "./video-person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports